import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';

const sampleInterval = 500;
const prevFPS = [];
const warningThreshold = 10;

let frames: number;
let prevTime: number;

@Component({
  selector: 'app-view-iphone12-warning',
  templateUrl: './view-iphone12-warning.component.html',
  styleUrls: ['./view-iphone12-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewIphone12WarningComponent implements OnInit, OnDestroy {

  shown = false;
  sampling = false;

  constructor(
    private storageService: StorageService,
    private changeRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (!this.storageService.getLocalItem(StorageItemEnum.Iphone12Warning)) {
      this.testDevices();
    }
  }

  ngOnDestroy(): void {
    this.sampling = false;
  }

  testDevices () {
    // https://stackoverflow.com/questions/58087446/all-media-queries-for-iphone-12-pro-max-mini-and-older-iphones
    const iphone12Query = window.matchMedia('only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3)');

    const iphone12maxQuery = window.matchMedia('only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3)');

    const ipadAir2020Query = window.matchMedia('only screen and (device-width: 820px) and (device-height: 1180px) and (-webkit-device-pixel-ratio: 2)');

    const queryMatch = iphone12Query.matches || iphone12maxQuery.matches || ipadAir2020Query.matches;

    const deviceTest = /iPhone|iPad/.test(navigator.userAgent);

    const osTest = /OS\s14/.test(navigator.userAgent);

    if (queryMatch && deviceTest && osTest) {
      this.startFrameSampling();
    }
  }

  startFrameSampling() {
    this.sampling = true;

    frames = 0;
    prevTime = Date.now();

    const sampleFPS = () => {

      if (this.frame()) {

        this.shown = true;
        this.changeRef.markForCheck();

      } else if (this.sampling) {
        requestAnimationFrame(sampleFPS);
      }

    };

    requestAnimationFrame(sampleFPS); 
  }

  frame () {
    frames++;
  
    const time = Date.now();
  
    if (time >= prevTime + sampleInterval) {
      const fpInterval = (frames * sampleInterval ) / ( time - prevTime );
      const fps = Math.floor( fpInterval * (1000 / sampleInterval) ); 
        
      prevFPS.push(fps);
      
      if (prevFPS.length > 3) {
        prevFPS.shift();
      }
  
      if (prevFPS.length === 3) {
        const prevFPSAverage = (prevFPS[0] + prevFPS[1] + prevFPS[2]) / 3;
        
        if (prevFPSAverage < warningThreshold) {
          return true;
        }
      }

      prevTime = time;
      frames = 0;
    }  
  }

  handleDismiss() {
    this.shown = false;
    this.changeRef.markForCheck();
    this.storageService.setLocalItem(StorageItemEnum.Iphone12Warning, true);
  }

}
